import {
  colors,
  Grid,
  layers,
  media,
  radius,
  spacing,
} from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

type ReversableProps = {
  reverse?: boolean;
};

export const FloatCardsWrapperContainer = styled.div`
  background-color: ${colors.neutral_extra_light};
`;

export const CardsWrapper = styled(Grid.Wrapper)`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(24, 1fr);
`;

export const ContentWrapper = styled.div<ReversableProps>`
  ${({ reverse }) => css`
    padding: ${spacing.medium};
    background-color: ${colors.light};
    border-radius: ${radius.medium};
    display: grid;
    grid-column-start: 1;
    grid-column-end: none;
    grid-row-start: 1;
    grid-row-end: none;
    // NOTE: This was needed in order to position the white card in front of the image
    z-index: calc(${layers.above} + 1);

    ${media.greaterThan('tablet')`
      ${
        reverse
          ? css`
              grid-column-start: 1;
              grid-column-end: 10;
            `
          : css`
              grid-column-start: 4;
              grid-column-end: none;
            `
      }

    grid-row-start: 1;
    grid-row-end: 24;
    padding: ${spacing.large};
    `}
  `}
`;

export const ImageWrapper = styled.div<ReversableProps>`
  ${({ reverse }) => css`
    overflow: hidden;
    display: grid;

    ${reverse
      ? css`
          grid-column-start: 4;
          grid-row-start: 2;
          grid-row-end: none;
          grid-column-end: none;
        `
      : css`
          grid-column-start: 1;
          grid-row-start: 2;
          grid-row-end: none;
          grid-column-end: 10;
        `}

    z-index: ${layers.above};
    position: relative;
    border-radius: ${radius.medium};
  `}
`;
